// extracted by mini-css-extract-plugin
export default {"warning_box":"style_warning_box__q+F12"};